import {
    Button,
    Modal,
    Table,
    Row,
    Col,
    Alert,
    Form,
    Input,
    InputNumber,
    Select,
    DatePicker,
    message,
    ConfigProvider,
    theme
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

import { useAuth } from "../../contexts/auth-context";
import {
    getFees,
    saveFee,
    archiveFee
} from '../../rest/admin/fees';

import './styles/AdminFees.css';

const AdminFees = (props) => {
    const { transactions = [], inProgress = false } = props;
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [newFeeModal, setNewFeeModal] = useState(false);
    const [newFeeloading, setNewFeeLoading] = useState(false);
    const [error, setError] = useState(null);
    const [newFeeError, setNewFeeError] = useState(null);
    const auth = useAuth();
    const loginEmail = auth.currentUser?.email;
    const [newFeeForm] = Form.useForm();

    const cryptoAccount = useSelector(state => state.cryptoAccount.account);
    const signedInWithMetamask = cryptoAccount.data?.exchange?.toLowerCase() === 'metamask';

    const fetchFees = async () => {
        try {
            const response = await getFees();
            if (response.data) {
                setData(response.data);
            }
            setLoadingData(false);
        } catch (error) {
            // If the error response indicates an expired token, sign out the user
            if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
                auth.signOut();
            }

            setLoadingData(false);
            const errorData = error.response?.data;
            if (errorData?.errorCode) { // This means the error is our customized error from the server
                setError(errorData.message);
                return;
            }

            setError(error.message);
        }
    }


    const onArchiveFee = async (fee) => {
        setLoading(true);

        try {
            await archiveFee(fee._id, { status: true });
            const response = await getFees();
            if (response.data) {
                setData(response.data);
            }
            setLoading(false);

        } catch (error) {
            // If the error response indicates an expired token, sign out the user
            if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
                auth.signOut();
            }

            setLoading(false);
            const errorData = error.response?.data;
            if (errorData?.errorCode) { // This means the error is our customized error from the server
                setError(errorData.message);
                return;
            }

            if (errorData && typeof errorData === 'string') { // This means the error is our customized error from the server
                setError(errorData);
                return;
            }

            setError(error.message);
        }
    }

    const showArchiveModal = (fee) => {
        Modal.confirm({
            title: 'Are you sure you want to archive this fee?',
            content: (
                <p>
                    You won't be able to reverse this operation. Click yes if you're sure.
                </p>
            ),
            maskClosable: true,
            closable: true,
            visible: false, // Start hidden
            okText: 'Yes',
            onOk: () => {
                onArchiveFee(fee);
            },
            onCancel: () => setLoading(false)

        });
    }

    const columns = [
        {
            title: "User",
            dataIndex: "user",
            key: "user",
            fixed: "left",
            width: "200px",
        },
        {
            title: "Referrer",
            dataIndex: "referrer",
            key: "referrer",
            // fixed: "left",
            width: "200px",
        },
        {
            title: "Fee Amount Percenatge (%)",
            dataIndex: "fee_amount_percentage",
            key: "fee_amount_percentage",
            width: "150px",
        },
        {
            title: "Fee to referrer Percenatge (%)",
            dataIndex: "fee_to_referrer_percentage",
            key: "fee_to_referrer_percentage",
            width: "150px",
        },
        {
            title: "User Type",
            dataIndex: "user_type",
            key: "user_type",
            // fixed: "left",
            width: "200px",
        },
        {
            title: "Fee structure",
            dataIndex: "fee_structure",
            key: "fee_structure",
            // fixed: "left",
            width: "200px",
        },
        {
            title: "Expiration date",
            dataIndex: "expiration_date",
            key: "expiration_date",
            // fixed: "left",
            width: "200px",
        },
        {
            title: "Pay after",
            dataIndex: "pay_after",
            key: "pay_after",
            // fixed: "left",
            width: "200px",
        },
        {
            title: "Pay after currency",
            dataIndex: "pay_after_currency",
            key: "pay_after_currency",
            // fixed: "left",
            width: "200px",
        },
        {
            title: "Grabby",
            dataIndex: "grabby",
            key: "grabby",
            // fixed: "left",
            width: "200px",
        },
        {
            title: "Archived",
            dataIndex: "archived",
            key: "archived",
            // fixed: "left",
            width: "200px",
            render: (value) => value ? 'yes' : 'no'
        },
        {
            title: "Action",
            dataIndex: "",
            key: "x",
            width: "200px",
            render: (_, record) => {
                return (
                    <Button
                        type="primary"
                        style={{ paddingLeft: '30px', paddingRight: '30px' }}
                        disabled={record.archived || loading}
                        onClick={() => showArchiveModal(record)}
                    >
                        Archive
                    </Button>
                )
            },
        },
    ];

    const handleNewFee = async () => {
        setNewFeeError('');
        setNewFeeLoading(true);

        try {
            const formValues = await newFeeForm.validateFields();
            if (formValues.expiration_date) {
                formValues.expiration_date = formValues.expiration_date.toISOString();
            }
            
            await saveFee(formValues);

            const response = await getFees();
            if (response.data) {
                setData(response.data);
            }
            
            setNewFeeModal(false);
            setNewFeeLoading(false);
            newFeeForm.resetFields();

        } catch (error) {
            // If the error response indicates an expired token, sign out the user
            if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
                auth.signOut();
            }

            setNewFeeLoading(false);
            
            // If is AntDesign validation errors, just return as they are already displayed on the screen
            if (error.errorFields?.length) {
                return;
            }

            const errorData = error.response?.data;
            if (errorData?.errorCode) { // This means the error is our customized error from the server
                setNewFeeError(errorData.message);
                return;
            }

            if (errorData && typeof errorData === 'string') { // This means the error is our customized error from the server
                setNewFeeError(errorData);
                return;
            }

            setNewFeeError(error.message);
        }
    }

    useEffect(() => {
        fetchFees();
    }, [])


    const validateMessages = {
        required: "${label} is required!",
        types: {
            email: "${label} is not a valid email!",
            number: "${label} is not a valid number!",
        },
        number: {
            range: "${label} must be between ${min} and ${max}",
        },
    };

    return (
        <div className="admin-fee-page">
            <h2 className="text-center">Fees</h2>
            {
                error && (
                    <Row style={{ marginBottom: '20px' }}>
                        <Col
                            xs={{ span: 24 }}
                            md={{ span: 16, offset: 4 }}
                            style={{ marginTop: "10px" }}
                        >
                            <Alert className="text-center" title={error} type="error" />
                        </Col>
                    </Row>
                )
            }
            <div className="text-white">
                <Row justify="end" align="middle">
                    <Col className="admin-new-fee-col" span="24">
                        <Button
                            type="primary"
                            onClick={() => setNewFeeModal(true)}
                        >
                            New Fee
                        </Button>
                    </Col>
                </Row>
            </div>
            <Table
                columns={columns}
                dataSource={data}
                scroll={{ x: 1024 }}
                loading={loadingData}
            //onRow={onRow}
            />
            <ConfigProvider
                theme={{
                    algorithm: theme.defaultAlgorithm,
                }}
            >
                <Modal // Info Modal for Coinbase Signin
                    title="New Fee:"
                    centered
                    open={newFeeModal}
                    onOk={() => handleNewFee()}
                    okText="Save fee"
                    onCancel={() => setNewFeeModal(false)}
                    confirmLoading={newFeeloading}
                // width={700} // width in px
                >

                    {
                        newFeeError && (
                            <Row style={{ marginBottom: '20px' }}>
                                <Col
                                    xs={{ span: 24 }}
                                    md={{ span: 16, offset: 4 }}
                                    style={{ marginTop: "10px" }}
                                >
                                    <Alert title={newFeeError} type="error" />
                                </Col>
                            </Row>
                        )
                    }

                    <Form
                        labelCol={{
                            // xs: { span: 24 },
                            // md: { span: 24 }
                        }}
                        wrapperCol={{
                            // xs: { span: 24 },
                            // md: { span: 24 },
                        }}
                        form={newFeeForm}
                        name="newFee"
                        // onFinish={onFinish}
                        validateMessages={validateMessages}
                        // style={{  margin: "auto", }}
                    >

                        <Form.Item
                            name={"user_type"}
                            label={"User Type"}
                            rules={[{ required: true }]}
                            className="form-item"
                        >
                            <Select
                                placeholder={"User Type"}
                                options={[
                                    {value: 'email', label: 'Email'},
                                    {value: 'domain', label: 'Domain'},
                                ]}
                                disabled={newFeeloading} 
                            />
                        </Form.Item>
                        <Form.Item
                            name={"user"}
                            label={"User"}
                            rules={[{ required: true }]}
                            className="form-item"
                        >
                            <Input placeholder={"User"} maxLength={225} disabled={newFeeloading} />
                        </Form.Item>
                        <Form.Item
                            name={"fee_amount_percentage"}
                            label={"Fee amount percentage (%)"}
                            rules={[{ required: true }]}
                            className="form-item"
                        >
                            <InputNumber
                                placeholder={"1 = 1%"}
                                style={{ width: "100%" }}
                                min={0}
                                disabled={newFeeloading}
                            />
                        </Form.Item>
                        <Form.Item
                            name={"fee_structure"}
                            label={"Fee structure"}
                            rules={[{ required: true }]}
                            className="form-item"
                        >
                            <Select 
                                placeholder={"Fee structure"} 
                                options={[
                                    { value: 'simple_referrer', label: 'Simple referrer'}
                                ]} 
                                disabled={newFeeloading} 
                            />
                        </Form.Item>
                        <Form.Item
                            name={"referrer"}
                            label={"Referrer email"}
                            rules={[{ required: false }, {type: 'email'}]}
                            className="form-item"
                        >
                            <Input placeholder={"Referrer email"} type="email" maxLength={225} disabled={newFeeloading} />
                        </Form.Item>
                        <Form.Item
                            name={"fee_to_referrer_percentage"}
                            label={"Fee to referrer percentage (%)"}
                            rules={[{ required: false }]}
                            className="form-item"
                        >
                            <InputNumber
                                placeholder={"50 = 50% of platform fees"}
                                style={{ width: "100%" }}
                                min={0}
                                disabled={newFeeloading}
                            />
                        </Form.Item>
                        <Form.Item
                            name={"expiration_date"}
                            label={"Expiration date"}
                            rules={[{ required: false }]}
                            className="form-item"
                        >
                            <DatePicker style={{ width: '100%'}} disabled={newFeeloading} />
                        </Form.Item>
                        <Form.Item
                            name={"pay_after"}
                            label={"Pay after"}
                            rules={[{ required: false }]}
                            className="form-item"
                        >
                            <InputNumber
                                placeholder={"Pay after"}
                                style={{ width: "100%" }}
                                min={0}
                                disabled={newFeeloading}
                            />
                        </Form.Item>
                        <Form.Item
                            name={"pay_after_currency"}
                            label={"Pay after currency"}
                            rules={[{ required: false }]}
                            className="form-item"
                        >
                            <Select 
                                placeholder={"Pay after currency"}
                                options={[
                                    { value: 'USDC', label: 'USDC'}
                                ]} 
                                disabled={newFeeloading} 
                            />
                        </Form.Item>
                        <Form.Item
                            name={"grabby"}
                            label={"Grabby"}
                            rules={[{ required: false }]}
                            className="form-item"
                        >
                            <Select 
                                placeholder={"Grabby"}
                                options={[
                                    {value: 'no', label: 'No'},
                                    {value: 'yes', label: 'Yes'},
                                ]} 
                                disabled={newFeeloading} 
                            />
                        </Form.Item>
                    </Form>
                </Modal>
            </ConfigProvider>
        </div>
    );
};

export default AdminFees;
